import {useEffect, useLayoutEffect} from 'react';

/**
 * 카피 : https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
 * usehooks-ts 를 그대로 install 해서 사용하다가 이 라이브러리의 dist 버전이 ios 13.2 에서 동작하지 않아 필요한 것만 카피함
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
